import React, { PureComponent, ReactElement } from 'react';

import { SpreaderAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType, ContainerProvider, Value } from '@philips-emr/tws-core';
import { array, arrayOf, element, list, object, oneOfType, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { getLostProps, isObject, propagateData } from '@philips-emr/tws-utils';

export interface SpreaderProps {
  children: ReactElement | ReactElement[];
  data: Record<string, Value> | Record<string, Value>[];
  entries?: string[];
  uuid: string;
}

@AwesomeComponent({ type: ComponentType.BEHAVIOR, api: SpreaderAPI })
class Spreader extends PureComponent<SpreaderProps> {
  static propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    data: oneOfType([object, array]).notEnumerable(),
    entries: list,
    uuid: string,
  };

  static defaultProps = {
    data: {},
    entries: [],
  };

  spread = (data: Record<string, Value> | Record<string, Value>[], entries?: string[]): Record<string, Value> => {
    
    if (Array.isArray(data) || !isObject(data) || !entries || entries.length === 0) {
      return {};
    }

    const result: Record<string, Value> = {};

    for (const entry of entries) {
      if (entry in data) {
        result[entry] = data[entry];
      }
    }

    return result;
  };

  render(): ReactElement | ReactElement[] | null {
    const { children, uuid, data, entries } = this.props;
    const lostProps = getLostProps(Spreader.propTypes, this.props);

    if (React.Children.count(children) === 0) {
      const Container = ContainerProvider.provide(this);

      if (!Container) {
        return null;
      }

      return <Container className="u-expand" uuid={uuid}/>;
    }

    const spreadData = this.spread(data, entries);

    return propagateData(children, data, { ...lostProps, ...spreadData });
  }
}

export default Spreader;
